import React from "react"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { EScheduleListType, IDate, IAssignedEmployeeConstraint, IScheduleDocument, ISchedulePatternTemplate, IScheduleDailyTimelineData, IScheduleShift, TimeBarViewType, IUserDocument, IJobDocument, IClientDocument, IScheduleDelay, EDayOfWeek } from "../../../models"
import { FloatingActionButton, SelectField, MenuItem, Paper } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import ScheduleDetailMonthlyWeeklyView from "./ScheduleDetailMonthlyWeeklyView"
import _ from "lodash"
import * as api from "../../../api"
import AppStateStore from "../../../stores/AppStateStore"
import UnAssignEmployeeDialog from "../assign_employee/UnAssignEmployeeDialog"
import CheckAssignedEmployeeConstraintDialog from "../assign_employee/CheckAssignedEmployeeConstraintDialog"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
import moment from "moment"
import * as timeHelper from "../../../helpers/timeHelper"
import AssignEmployeeDrawer from "../assign_employee/AssignEmployeeDrawer"

interface IProps {
  readonly?: boolean
  type?: EScheduleListType
  schedule: IScheduleDocument
  handleChange(schedule: IScheduleDocument, successMsg: string, checkValidationShiftIds: string[]): void
  handleChangeWithoutApiCall(schedule: IScheduleDocument): void
  callUpdateApi?(): void
  handleShowTimecardPopup?(employeeId: string, referenceDate: IDate): void

  // it's true on ScheduleEditDialog 
  updateScheduleWithoutCheckAssignedEmployeeConstraint?: boolean

  scheduleJob: IJobDocument
  scheduleClient: IClientDocument
}
interface IState {
  viewType: TimeBarViewType
  assignPatternTemplate: ISchedulePatternTemplate
  assignedEmployeeConstraints: IAssignedEmployeeConstraint
  unAssignPatternTemplate: ISchedulePatternTemplate
  payloadForCheckAssignedEmployeeConstraintDialog: any
  openTimecardPopup?: boolean
  employeeIdForTimecardPopup?: string
  referenceDateForTimecardPopup?: IDate
  //add shift disabled by the start/end dates of job
  addShiftDisabled: boolean
}

export default class ScheduleTimeInfoDetail extends React.Component<IProps, IState> {
  private ScheduleDetailMonthlyWeeklyView
  private originalSchedule
  constructor(props) {
    super(props)
    this.state = {
      viewType: "week",
      assignPatternTemplate: null,
      assignedEmployeeConstraints: null,
      unAssignPatternTemplate: null,
      payloadForCheckAssignedEmployeeConstraintDialog: null,
      addShiftDisabled: false
    }
    autobind(this)
  }

  handleAddPatternTemplates(newPatternTemplates: ISchedulePatternTemplate[]) {
    const schedule = _.cloneDeep(this.props.schedule)
    newPatternTemplates.forEach(patternTemplate => {
      schedule.Schedules.push(patternTemplate)
    })
    this.props.handleChange(schedule, strings.Shift_added_successfully, scheduleHelper.getAllShiftIds(newPatternTemplates))
  }

  handleDeletePatternTemplates(selectedPatternTemplates: ISchedulePatternTemplate[]) {
    if (selectedPatternTemplates.find(pt => pt.ShiftTemplates.find(st => st.Used) !== undefined)) {
      AppStateStore.setProgressSnackbarContent(strings.Cannot_delete_shifts_already_in_use)
    }
    else {
      const schedule = _.cloneDeep(this.props.schedule)
      if (schedule.PublishInfo && schedule.PublishInfo.Published) {
        schedule.Schedules.map(pt => {
          if (selectedPatternTemplates.find(selectedPt => selectedPt.Id === pt.Id)) {
            pt.Deleted = true
            pt.ShiftTemplates.forEach(st => {
              st.Deleted = true
            })
          }
        })
        schedule.Schedules = schedule.Schedules.filter(pt => pt.AssignedUserId || !pt.Deleted)
      }
      else {
        schedule.Schedules = schedule.Schedules.filter(pt =>
          selectedPatternTemplates.find(selectedPt => selectedPt.Id === pt.Id) === undefined
        )
      }
      this.props.handleChange(schedule, strings.Shift_deleted_successfully, scheduleHelper.getAllShiftIds(selectedPatternTemplates))
    }
  }

  handleUpdateTimelineData(timelineItem: IScheduleDailyTimelineData, shiftTemplate: IScheduleShift) {
    const schedule = _.cloneDeep(this.props.schedule)
    let patternTemplateIndexOf
    schedule.Schedules.forEach((pt, i) =>
      pt.ShiftTemplates.forEach(st => {
        if (st.Id === shiftTemplate.Id) {
          patternTemplateIndexOf = i
          st.StartTime = timelineItem.StartTime
          st.EndTime = timelineItem.EndTime
        }
      })
    )

    this.originalSchedule = _.cloneDeep(this.props.schedule)
    this.props.handleChangeWithoutApiCall(schedule)
    this.updateScheduleWithCheckAssignedEmployeeConstraint(schedule.Schedules[patternTemplateIndexOf], schedule, strings.Shift_time_updated_successfully)
  }

  checkValidateNewTimeline(timelineItem: IScheduleDailyTimelineData, updateShiftTemplate: IScheduleShift, patternTemplate: ISchedulePatternTemplate): boolean {
    const updatedShiftTemplate = _.cloneDeep(updateShiftTemplate)
    updatedShiftTemplate.StartTime = timelineItem.StartTime
    updatedShiftTemplate.EndTime = timelineItem.EndTime
    updatedShiftTemplate.Breaks = timelineItem.Breaks
    const isOverlapValidate = scheduleHelper.checkOverlapShifts(
      updatedShiftTemplate,
      patternTemplate.ShiftTemplates.filter((item) => item.Id !== updatedShiftTemplate.Id))
    let isBreakValidate = true
    if (isOverlapValidate) {
      isBreakValidate = scheduleHelper.checkValidateShiftBreakTimes(updatedShiftTemplate)
      !isBreakValidate && AppStateStore.setProgressSnackbarContent(strings.Break_Time_Window_should_be_fall_in_shift_time)
    }
    else {
      AppStateStore.setProgressSnackbarContent(strings.Cannot_overlap_shift_times)
    }
    return isOverlapValidate && isBreakValidate
  }

  handleDeleteTimelineItem(deleteShiftTemplate: IScheduleShift) {
    const patternTemplate = this.props.schedule.Schedules.find(pt => pt.ShiftTemplates.find(st => st.Id === deleteShiftTemplate.Id) !== undefined)
    this.handleDeletePatternTemplates([patternTemplate])
  }

  handleUpdateDailyBudget(budgetDay, dayIndex) {
    const schedule = _.cloneDeep(this.props.schedule)
    if (!schedule.Budget.Days) {
      schedule.Budget = {
        Days: []
      }
      schedule.Budget.Days.push(budgetDay)
    } else {
      schedule.Budget.Days[dayIndex] = budgetDay
    }

    this.props.handleChange(schedule, "Updated Schedule Budget", null)
  }

  handleAddTimelineItem(addedPatternTemplate: ISchedulePatternTemplate) {
    const schedule = _.cloneDeep(this.props.schedule)
    let indexOf
    schedule.Schedules.forEach((item, index) => {
      if (item.Id === addedPatternTemplate.Id)
        indexOf = index
    })
    schedule.Schedules[indexOf] = addedPatternTemplate
    this.updateScheduleWithCheckAssignedEmployeeConstraint(addedPatternTemplate, schedule, strings.Shift_added_successfully)
  }

  handleUpdateTimelineItem(updatedShift: IScheduleShift) {
    const schedule = _.cloneDeep(this.props.schedule)
    const patternTemplate = schedule.Schedules.find(pt => pt.ShiftTemplates.find(st => st.Id === updatedShift.Id) !== undefined)
    let indexOf
    patternTemplate.ShiftTemplates.forEach((st, index) => {
      if (st.Id === updatedShift.Id) {
        indexOf = index
      }
    })
    patternTemplate.ShiftTemplates[indexOf] = updatedShift
    this.originalSchedule = _.cloneDeep(this.props.schedule)
    this.updateScheduleWithCheckAssignedEmployeeConstraint(patternTemplate, schedule, strings.Shift_updated_successfully)
  }

  updateScheduleWithCheckAssignedEmployeeConstraint(checkPatternTemplate: ISchedulePatternTemplate, schedule: IScheduleDocument, successMsg: string) {
    if (!this.props.updateScheduleWithoutCheckAssignedEmployeeConstraint && checkPatternTemplate.AssignedUserId) {
      api.getEmployeeScheduleShiftConstraints(checkPatternTemplate.AssignedUserId, [checkPatternTemplate], this.props.schedule.MasterSchedule).then(res => {
        if (res.data.length === 0) {
          this.props.handleChange(schedule, successMsg, scheduleHelper.getAllShiftIds([checkPatternTemplate]))
          this.originalSchedule = null
        }
        else {
          api.getUser(checkPatternTemplate.AssignedUserId).then(res1 => {
            AppStateStore.setProgressSnackbarContent("")
            this.setState({
              assignedEmployeeConstraints: {
                SchedulePatternTemplate: checkPatternTemplate,
                Constraints: res.data,
                Employee: res1.data
              },
              payloadForCheckAssignedEmployeeConstraintDialog: {
                Schedule: schedule,
                SuccessMsg: successMsg
              }
            })
          })
        }
      })
    }
    else {
      this.props.handleChange(schedule, successMsg, scheduleHelper.getAllShiftIds([checkPatternTemplate]))
    }
  }

  handleDragPatternTemplate(dragDropPatternTemplateId: string, moveUp: number, reorderItems: ISchedulePatternTemplate[]) {
    const schedule = this.props.schedule
    const dragDropPTIndexOfInDay = reorderItems.findIndex(item => item.Id === dragDropPatternTemplateId)
    const otherPTId = reorderItems[dragDropPTIndexOfInDay - moveUp].Id
    const dragDropPTIndexOfInSchedule = schedule.Schedules.findIndex(item => item.Id === dragDropPatternTemplateId)
    const otherPTIndexOfInSchedule = schedule.Schedules.findIndex(item => item.Id === otherPTId)
    const otherPT = schedule.Schedules[otherPTIndexOfInSchedule]

    schedule.Schedules[otherPTIndexOfInSchedule] = schedule.Schedules[dragDropPTIndexOfInSchedule]
    schedule.Schedules[dragDropPTIndexOfInSchedule] = otherPT
    this.props.handleChangeWithoutApiCall(schedule)
  }

  handleUnAssign(unAssignPatternTemplates: ISchedulePatternTemplate[]) {
    this.setState({ unAssignPatternTemplate: null })
    if (unAssignPatternTemplates.length === 0)
      return
    const schedule = scheduleHelper.unAssignEmployeeForSchedule(this.props.schedule, unAssignPatternTemplates)
    this.props.handleChange(schedule, strings.Shift_unassigned_successfully, scheduleHelper.getAllShiftIds(unAssignPatternTemplates))
  }

  handleClonePatternTemplates(clonePatternTemplates: ISchedulePatternTemplate[]) {
    const schedule = _.cloneDeep(this.props.schedule)
    clonePatternTemplates.forEach(patternTemplate => {
      schedule.Schedules.push(patternTemplate)
    })
    this.props.handleChange(schedule, strings.Shifts_cloned_successfully, scheduleHelper.getAllShiftIds(clonePatternTemplates))
  }

  handleDelay(delayDay: number, delayLength: number, delayNote: string) {
    const schedule = _.cloneDeep(this.props.schedule)
    const delayDateTime = moment(timeHelper.keepConvertUTCToLocal(schedule.StartDate)).add(delayDay, "day")

    schedule.Schedules = this.delayPatternTemplates(schedule.Schedules, delayDateTime, delayLength, schedule.ExcludeWeekends)
    if (schedule.HiddenSchedules) {
      schedule.HiddenSchedules = this.delayPatternTemplates(schedule.HiddenSchedules, delayDateTime, delayLength, schedule.ExcludeWeekends)
    }

    if (schedule.Budget && schedule.Budget.Days) {
      schedule.Budget.Days = schedule.Budget.Days.map(i => {
        const delayLengthWithExcludeWeekends = this.getDelayLengthWithExcludeWeekends(i.Date, delayLength, schedule.ExcludeWeekends)
        i.Date = moment(timeHelper.keepConvertUTCToLocal(i.Date)).add(delayLengthWithExcludeWeekends, "day").utc(true).format()
        return i
      })
    }

    if (!schedule.Delays) {
      schedule.Delays = []
    }
    const delay: IScheduleDelay = {
      DateTimeLocal: delayDateTime.utc(true).format(),
      ActionDateTimeLocal: moment().utc(true).format(),
      ActionUserId: AuthenticationStore.getLoggedInUser().Id,
      ActionUserName: `${AuthenticationStore.getLoggedInUser().FirstName} ${AuthenticationStore.getLoggedInUser().LastName}`,
      DelayDayLength: delayLength,
      Note: delayNote
    }
    schedule.Delays.push(delay)

    const stStartDates: IDate[] = []
    schedule.Schedules.forEach(i =>
      i.ShiftTemplates.forEach(st =>
        stStartDates.push(scheduleHelper.getTimeFromSimpleTime(st.StartTime))
      )
    )
    if (schedule.HiddenSchedules) {
      schedule.HiddenSchedules.forEach(i =>
        i.ShiftTemplates.forEach(st =>
          stStartDates.push(scheduleHelper.getTimeFromSimpleTime(st.StartTime))
        )
      )
    }

    const maxDate = stStartDates.reduce((a, b) => {
      return a > b ? a : b
    })
    schedule.EndDate = moment(maxDate).startOf("day").isAfter(moment(timeHelper.keepConvertUTCToLocal(schedule.EndDate)).startOf("day")) ?
      moment(maxDate).endOf("day").utc(true).format() :
      schedule.EndDate

    this.props.handleChange(schedule, strings.Schedule_delayed_successfully, null)
  }

  handleAddAdditionalDay() {
    AppStateStore.setConfirmDialogContent({
      content: strings.Are_you_sure_you_want_to_add_an_additional_day_to_the_end_of_the_schedule,
      confirm: () => {
        const schedule = _.cloneDeep(this.props.schedule)
        schedule.EndDate = moment(timeHelper.keepConvertUTCToLocal(schedule.EndDate)).add(1, "day").utc(true).format()
        this.props.handleChange(schedule, strings.Added_an_additional_day_successfully, null)
      }
    })
  }

  handleDeleteEmptyExtraDay(cb: () => void) {
    AppStateStore.setConfirmDialogContent({
      content: strings.Are_you_sure_you_want_to_delete_empty_extra_day,
      confirm: () => {
        const schedule = _.cloneDeep(this.props.schedule)
        schedule.EndDate = moment(timeHelper.keepConvertUTCToLocal(schedule.EndDate)).add(-1, "day").utc(true).format()
        schedule.Schedules = schedule.Schedules
          .filter(i =>
            i.ShiftTemplates
              .find(i => scheduleHelper.getTimeFromSimpleTime(i.StartTime).isBefore(timeHelper.keepConvertUTCToLocal(schedule.EndDate)))
          )
        this.props.handleChange(schedule, strings.Successfully_deleted, null)
        cb()
      }
    })
  }

  delayPatternTemplates(patternTemplates: ISchedulePatternTemplate[], delayDateTime: moment.Moment, delayLength: number, excludeWeekends: boolean): ISchedulePatternTemplate[] {
    return patternTemplates.map(i => {
      if (!i.Deleted) {
        i.ShiftTemplates = i.ShiftTemplates.map(st => {
          if (!st.Used) {
            const stDay = scheduleHelper.getTimeFromSimpleTime(st.StartTime).startOf("day")
            if (stDay.isSameOrAfter(delayDateTime.startOf("day"))) {
              const delayLengthWithExcludeWeekends = this.getDelayLengthWithExcludeWeekends(stDay, delayLength, excludeWeekends)
              st.StartTime = scheduleHelper.getSimpleTimeFromTime(scheduleHelper.getTimeFromSimpleTime(st.StartTime).add(delayLengthWithExcludeWeekends, "day"))
              st.EndTime = scheduleHelper.getSimpleTimeFromTime(scheduleHelper.getTimeFromSimpleTime(st.EndTime).add(delayLengthWithExcludeWeekends, "day"))
              st.StartDateTime = moment(timeHelper.keepConvertUTCToLocal(st.StartDateTime)).add(delayLengthWithExcludeWeekends, "day").utc(true).format()
              st.EndDateTime = moment(timeHelper.keepConvertUTCToLocal(st.EndDateTime)).add(delayLengthWithExcludeWeekends, "day").utc(true).format()
              if (st.Breaks) {
                st.Breaks = st.Breaks.map(stBreak => {
                  stBreak.BreakWindowStartTime = scheduleHelper.getSimpleTimeFromTime(scheduleHelper.getTimeFromSimpleTime(stBreak.BreakWindowStartTime).add(delayLengthWithExcludeWeekends, "day"))
                  stBreak.BreakWindowEndTime = scheduleHelper.getSimpleTimeFromTime(scheduleHelper.getTimeFromSimpleTime(stBreak.BreakWindowEndTime).add(delayLengthWithExcludeWeekends, "day"))
                  stBreak.BreakWindowStartDateTime = moment(timeHelper.keepConvertUTCToLocal(stBreak.BreakWindowStartDateTime)).add(delayLengthWithExcludeWeekends, "day").utc(true).format()
                  stBreak.BreakWindowEndDateTime = moment(timeHelper.keepConvertUTCToLocal(stBreak.BreakWindowEndDateTime)).add(delayLengthWithExcludeWeekends, "day").utc(true).format()
                  return stBreak
                })
              }
            }
          }
          return st
        })
      }
      return i
    })
  }

  getDelayLengthWithExcludeWeekends(day: IDate, delayLength: number, excludeWeekends: boolean): number {
    if (excludeWeekends) {
      let containWeekends = false
      for (let i = 0; i <= delayLength; i++) {
        const dayOfWeek = moment(day).add(i, "day").weekday()
        if (dayOfWeek === EDayOfWeek.Saturday || dayOfWeek === EDayOfWeek.Sunday) {
          containWeekends = true
        }
      }
      return containWeekends ? Number(delayLength) + 2 : delayLength
    }
    return delayLength
  }

  render() {
    return (
      <Paper zDepth={1} style={{ textAlign: "left", margin: 20, position: "relative", overFlow: "hidden" }}>
        <div style={{ padding: 10, paddingTop: 30, position: "relative" }} id="ScheduleViewPlace">
          {!this.props.readonly && permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditSchedule) && (
            this.state.viewType === "week" ?
              <FloatingActionButton
                data-intercom-target={"menu-Schedules-ScheduleTimeInfo-Btn-Add"}
                className="fixed-add"
                style={{ top: -30, right: 15, zIndex: 998 }}
                secondary={true}
                onTouchTap={() => !this.state.addShiftDisabled && this.ScheduleDetailMonthlyWeeklyView.setState({ openAddShiftDialog: true })}
                disabled={this.state.addShiftDisabled}
                title={this.state.addShiftDisabled ? strings.Current_selected_date_range_is_outside_of_the_Job_date_range : ""}
              >
                <ContentAdd />
              </FloatingActionButton> :
              <div style={{ position: "absolute", top: 20, right: 40 }}>
                {strings.Shifts_must_be_added_to_week_view}
              </div>
          )}
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <SelectField
              data-intercom-target={"menu-Schedules-ScheduleTimeInfo-Select-ViewType"}
              floatingLabelText={strings.View_Type}
              value={this.state.viewType}
              onChange={(e, key, payload) =>
                this.setState({ viewType: payload })
              }
              labelStyle={{ paddingRight: 0 }}
              style={{ width: 110 }}
              iconStyle={{ width: 20, padding: 0 }}
            >
              <MenuItem innerDivStyle={{ paddingLeft: 15, paddingRight: 0 }} value={"week"} primaryText={strings.Week_View} />
              <MenuItem innerDivStyle={{ paddingLeft: 15, paddingRight: 0 }} value={"month"} primaryText={strings.Month_View} />
            </SelectField>
          </div>
          <ScheduleDetailMonthlyWeeklyView
            ref={item => this.ScheduleDetailMonthlyWeeklyView = item}
            type={this.props.type}
            readonly={this.props.readonly}
            schedule={this.props.schedule}
            viewType={this.state.viewType}
            handleAssignEmployee={assignPatternTemplate => this.setState({ assignPatternTemplate })}
            handleUpdateTimelineData={this.handleUpdateTimelineData}
            checkValidateNewTimeline={this.checkValidateNewTimeline}
            handleDeleteTimelineItem={this.handleDeleteTimelineItem}
            handleDeletePatternTemplates={this.handleDeletePatternTemplates}
            handleUpdateTimelineItem={this.handleUpdateTimelineItem}
            handleShowTimecardPopup={(employeeIdForTimecardPopup, referenceDateForTimecardPopup) =>
              this.props.handleShowTimecardPopup &&
              this.props.handleShowTimecardPopup(employeeIdForTimecardPopup, referenceDateForTimecardPopup)
            }
            handleUnAssignEmployee={unAssignPatternTemplate => this.setState({ unAssignPatternTemplate })}
            handleDragPatternTemplate={this.handleDragPatternTemplate}
            handleDropPatternTemplate={this.props.callUpdateApi}
            handleAddPatternTemplates={this.handleAddPatternTemplates}
            handleAddTimelineItem={this.handleAddTimelineItem}
            handleUpdateDailyBudget={this.handleUpdateDailyBudget}
            handleChangeViewType={(viewType, selectedDate, cb) => this.setState({ viewType }, () => cb())}
            handleAutoAddShifts={(shiftPatternTemplates: ISchedulePatternTemplate[]) => {
              const schedule = _.cloneDeep(this.props.schedule)
              shiftPatternTemplates.forEach(shift => {
                schedule.Schedules.push(shift)
              })
              this.props.handleChange(schedule, strings.Shift_added_successfully, scheduleHelper.getAllShiftIds(shiftPatternTemplates))
            }}
            scheduleJob={this.props.scheduleJob}
            scheduleClient={this.props.scheduleClient}
            handleAddShiftDisabled={selectedWeekDay =>
              this.setState({
                addShiftDisabled:
                  !scheduleHelper.checkValidJobShiftDayByJobDate(this.props.scheduleJob, moment(this.props.schedule.StartDate).add(selectedWeekDay, "day"))
              })
            }
            handleClonePatternTemplates={this.handleClonePatternTemplates}
            handleDelay={this.handleDelay}
            handleAddAdditionalDay={this.handleAddAdditionalDay}
            handleDeleteEmptyExtraDay={this.handleDeleteEmptyExtraDay}
          />
        </div>
        {this.state.unAssignPatternTemplate &&
          <UnAssignEmployeeDialog
            schedule={this.props.schedule}
            unAssignPatternTemplate={this.state.unAssignPatternTemplate}
            handleClose={() => this.setState({ unAssignPatternTemplate: null })}
            handleUnAssign={this.handleUnAssign}
          />
        }
        {this.state.assignedEmployeeConstraints &&
          <CheckAssignedEmployeeConstraintDialog
            assignedEmployeeConstraints={this.state.assignedEmployeeConstraints}
            payload={this.state.payloadForCheckAssignedEmployeeConstraintDialog}
            handleClose={() => {
              this.setState({
                assignedEmployeeConstraints: null,
                payloadForCheckAssignedEmployeeConstraintDialog: null
              }, () => {
                this.props.handleChangeWithoutApiCall(this.originalSchedule)
                this.originalSchedule = null
              })
            }}
            handleSave={payload => {
              this.props.handleChange(payload.Schedule, payload.SuccessMsg, scheduleHelper.getAllShiftIds([this.state.assignedEmployeeConstraints.SchedulePatternTemplate]))
              this.setState({ assignedEmployeeConstraints: null, payloadForCheckAssignedEmployeeConstraintDialog: null })
              this.originalSchedule = null
            }}
          />
        }
        {this.state.assignPatternTemplate &&
          <AssignEmployeeDrawer
            schedule={this.props.schedule}
            open={!!this.state.assignPatternTemplate}
            assignPatternTemplate={this.state.assignPatternTemplate}
            handleClose={() => this.setState({ assignPatternTemplate: null })}
            handleAssign={(shiftIds: string[], assignEmployeeId: string) => {
              this.setState({ assignPatternTemplate: null })
              AppStateStore.setProgressSnackbarContent("loading")
              api.assignShift(assignEmployeeId, shiftIds).then(async () => {
                const res = await api.getSchedule(this.props.schedule.Id)
                this.props.handleChangeWithoutApiCall(res.data)
                AppStateStore.setProgressSnackbarContent(strings.Shift_assigned_successfully)
              })
            }}
            replaceSchedulePatternTemplate={schedulePatternTemplate => {
              const schedule = _.cloneDeep(this.props.schedule)
              const index = schedule.Schedules.findIndex(i => i.Id === schedulePatternTemplate.Id)
              if (index !== -1) {
                schedule.Schedules[index] = schedulePatternTemplate
                this.props.handleChangeWithoutApiCall(schedule)
              }
            }}
          />
        }
      </Paper>
    )
  }
}